<app-sidebar [routes]="routes" (onToggleSideNav)="onToggleSideNav($event)"></app-sidebar>
<div class="header-content" [ngClass]="getBodyClass()">
    <app-header [title]="title" [isMobile]="isMobile"></app-header>
</div>
<div id="main" class="body-content" [ngClass]="getBodyClass()">
    <router-outlet></router-outlet>
</div>